import React from 'react';
import FormStep from "../form-step";
import {Field, Form} from "formik";
import {renderField} from "../../../../utils/form-utils";
import * as Yup from "yup";
import ActionButtons from "../action-buttons";
import {CheckboxListField} from "../checkbox-list-field";
import StepLayout from "../step-layout";

const validationSchema = Yup.object().shape({
    cloud_workloads: Yup.string().required('Required'),
    clouds: Yup.array(Yup.string()).when('cloud_workloads', {
        is: 'Yes',
        then: Yup.array(Yup.string()).min(1, 'Select at least one').required('Required')
    }),
    aws_annual_spend: Yup.string().when(['cloud_workloads', 'clouds'], (cloud_workloads, clouds) => {
        if (cloud_workloads === 'Yes' && clouds.includes("AWS"))
            return Yup.string().required('Required')
    }),
    aws_in_production: Yup.string().when(['cloud_workloads', 'clouds'], (cloud_workloads, clouds) => {
        if (cloud_workloads === 'Yes' && clouds.includes("AWS"))
            return Yup.string().required('Required')
    }),
    aws_workloads_type: Yup.array(Yup.string()).when(['cloud_workloads', 'clouds'], (cloud_workloads, clouds) => {
        if (cloud_workloads === 'Yes' && clouds.includes("AWS"))
            return Yup.array(Yup.string()).min(1, 'Select at least one').required('Required')
    }),
});

const CloudWorkloads = ({data, onNext}) => {
    const initialValues = {
        cloud_workloads: data.cloud_workloads || '',
        clouds: data.clouds || [],
        aws_annual_spend: data.aws_annual_spend || '',
        aws_in_production: data.aws_in_production || '',
        aws_workloads_type: data.aws_workloads_type || []
    };

    return (
        <FormStep
            name="Cloud Workloads"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onNext={onNext}
        >
            {({
                  values
              }) => (
                <StepLayout actions={<ActionButtons />}>
                    <Field
                        type="select"
                        name="cloud_workloads"
                        component={renderField}
                        label="Are you running workloads on the Cloud today?"
                    >
                        <option value="">-- Please Select --</option>
                        <option value="Yes">Yes</option>
                        <option value="No / I don't know">No / I don't know</option>
                    </Field>

                    {values.cloud_workloads === 'Yes' &&
                        <>
                            <CheckboxListField
                                name="clouds"
                                items={["AWS", "Microsoft Azure", "Google Cloud", "IBM", "Rackspace", "Other", "I don't know"]}
                                label="What Clouds are you using today?"
                            />

                            {values.clouds.includes("AWS") &&
                                <>
                                    <Field
                                        type="select"
                                        name="aws_annual_spend"
                                        component={renderField}
                                        label="What is your current annual spend on AWS?"
                                    >
                                        <option value="">-- Please Select --</option>
                                        <option value="Under $250K">Under $250K</option>
                                        <option value="$250K-$1M">$250K-$1M</option>
                                        <option value="$1M+">$1M+</option>
                                        <option value="I don't know">I don't know</option>
                                    </Field>

                                    <Field
                                        type="select"
                                        name="aws_in_production"
                                        component={renderField}
                                        label="Are you in Production on AWS?"
                                    >
                                        <option value="">-- Please Select --</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Field>

                                    <CheckboxListField
                                        name="aws_workloads_type"
                                        items={[
                                            "Linux", "Windows", "Serverless", "Containers",
                                            "Big Data", "Analytics", "Gaming", "IoT",
                                            "Mobile", "AI/ML", "Storage", "Other",
                                            "I don't know"
                                        ]}
                                        label="What type of AWS workloads are you running?"
                                    />
                                </>
                            }
                        </>

                    }


                </StepLayout>
                )}
        </FormStep>
    )
}

export default CloudWorkloads;